import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CatalogMobileActionBarProps {
  children: ReactNode;
  className?: string;
}

export function CatalogMobileActionBar({ children, className }: CatalogMobileActionBarProps) {
  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur",
        "px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]",
        "lg:hidden",
        className
      )}
    >
      <div className="mx-auto flex max-w-lg flex-col gap-2">{children}</div>
    </div>
  );
}
